import type { ReactNode } from 'react';
import { createContext, useContext, useMemo } from 'react';

import type {
  CreatedPayoutDraftData,
  CreatedPayoutDraftDataProduct
} from 'api';

type DraftDefinitionContextProps = {
  draftId: number;
  product: CreatedPayoutDraftDataProduct;
  fieldDefinitions: Omit<CreatedPayoutDraftData, 'draft_id' | 'product'>;
};

const DraftDefinitionContext = createContext({} as DraftDefinitionContextProps);

type DraftDefinitionProviderProps = {
  children: ReactNode;
  fieldDefinitions: CreatedPayoutDraftData;
};

export const DraftDefinitionProvider = ({
  children,
  fieldDefinitions
}: DraftDefinitionProviderProps) => {
  const value = useMemo(() => {
    const { draft_id: draftId, product, ...definitions } = fieldDefinitions;
    return {
      draftId,
      product,
      fieldDefinitions: definitions
    };
  }, [fieldDefinitions]);

  return (
    <DraftDefinitionContext.Provider value={value}>
      {children}
    </DraftDefinitionContext.Provider>
  );
};

export const useDraftDefinition = () => useContext(DraftDefinitionContext);
